import React from 'react';
import Select from "react-select";

const MGSelect = ({labelName, selectValue, onChangeFn, optionsList,isMulti=false}) => {
    const customStyle = {
        control: (provided) => ({
            ...provided,
            borderColor: 'var(--p-color-border)',
            minHeight: '44px',
            boxShadow: 'none',
            '&:hover': {
                borderColor: 'var(--p-color-border-hover)',
            },
        }),
        singleValue: (provided) => ({
            ...provided,
            color: 'var(--p-color-text)',
        }),
        menu: (provided) => ({
            ...provided,
            backgroundColor: 'var(--p-color-bg)',
            borderColor: 'var(--p-color-border)',
            zIndex: 9999,
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected
                ? 'var(--p-color-bg-surface)'
                : state.isFocused
                    ? 'var(--p-color-bg-hover)'
                    : 'var(--p-color-bg-surface)',
            color: 'var(--p-color-text)',
            '&:active': {
                backgroundColor: 'var(--p-color-bg-active)',
            },
        }),
    };

    return (
        <div className="">
            <div className="Polaris-Labelled__LabelWrapper">
                <div className="Polaris-Label">
                    <label className="Polaris-Label__Text">
                        <span className="Polaris-Text--root Polaris-Text--bodyMd">{labelName}</span>
                    </label>
                </div>
            </div>
            <div className="Polaris-Connected">
                <div className="Polaris-Connected__Item Polaris-Connected__Item--primary">
                    <Select
                        label='My Curriences'
                        value={selectValue}
                        onChange={onChangeFn}
                        options={optionsList}
                        isMulti={isMulti}
                        styles={customStyle}
                        menuPortalTarget={document.body} // Render menu in the portal
                    />
                </div>
            </div>
        </div>
    );
};

export default MGSelect;
